export const TrailerType = [
  { value: "", label: "Select Trailer Type" },
  { value: "DryVan", label: "Dry Van" },
  { value: "Reefer", label: "Reefer" },
  { value: "Flatbed", label: "Flatbed" },
  { value: "StepDeckLowProfile", label: "Step Deck Low Profile" },
  { value: "StepDeckRegularProfile", label: "Step Deck Regular Profile" },
  { value: "RGN", label: "RGN" },
  { value: "Conestoga", label: "Conestoga" },
  { value: "Chassis", label: "Chassis" },
  { value: "Gainesville", label: "Gainesville" },
];
